import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { InfoIcon } from '../../../../components/info-icon';

const CustomCell = ({ field, row }) => {
	if (field === 'id') {
		return (
			<div className="custom-cell__id">
				<InfoIcon popupContent={`№ ${row[field]}`} link={row.link} />
			</div>
		);
	}

	if (field === 'icepack') {
		return (
			<Link className="custom-cell__link" to={row.link}>
				{row.icepack?.name}
			</Link>
		);
	}

	if (field === 'partner') {
		return row.icepack.partner?.name;
	}

	return row[field];
};

CustomCell.propTypes = {
	row: PropTypes.object.isRequired,
	field: PropTypes.string.isRequired,
};

export { CustomCell };
